export default "__VITE_ASSET__06dbf064__"